import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import type { Product } from '@reims-local/types';
import { shopApi } from '../lib/api';

export function Products() {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  async function load() {
    try {
      const res = await shopApi.listProducts();
      setProducts(res.data);
      setError(null);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { void load(); }, []);

  async function handleDelete(id: string) {
    if (!confirm('Supprimer ce produit ?')) return;
    try {
      await shopApi.deleteProduct(id);
      await load();
    } catch (err) {
      alert((err as Error).message);
    }
  }

  async function toggleAvailable(p: Product) {
    try {
      await shopApi.updateProduct(p.id, { is_available: !p.is_available });
      await load();
    } catch (err) {
      alert((err as Error).message);
    }
  }

  return (
    <>
      <div className="toolbar">
        <h2 style={{ margin: 0 }}>Catalogue ({products.length})</h2>
        <div className="spacer" />
        <Link to="/products/new"><button className="primary">+ Nouveau produit</button></Link>
      </div>

      {error && <div className="alert alert-error">{error}</div>}
      {loading ? (
        <p>Chargement…</p>
      ) : products.length === 0 ? (
        <div className="card"><p>Aucun produit. Ajoutez votre premier produit pour commencer.</p></div>
      ) : (
        <table>
          <thead>
            <tr>
              <th></th>
              <th>Nom</th>
              <th>Prix</th>
              <th>Stock</th>
              <th>Publié</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {products.map((p) => (
              <tr key={p.id}>
                <td>
                  <div className="product-photo-thumb" style={{ backgroundImage: p.photo_url ? `url(${p.photo_url})` : undefined }} />
                </td>
                <td>
                  <Link to={`/products/${p.id}`}>{p.name}</Link>
                  <div className="muted">{p.category ?? '—'}</div>
                </td>
                <td>{(p.price_cents / 100).toFixed(2)} €</td>
                <td>
                  {p.is_made_to_order ? (
                    <span className="muted">Sur commande</span>
                  ) : p.is_perishable ? (
                    <span>{p.stock} <span className="muted">(reset quotidien)</span></span>
                  ) : (
                    <span>{p.stock}</span>
                  )}
                </td>
                <td>
                  <button onClick={() => toggleAvailable(p)} className={p.is_available ? '' : 'ghost'}>
                    {p.is_available ? '✓ Oui' : '— Non'}
                  </button>
                </td>
                <td>
                  <Link to={`/products/${p.id}`}><button>Éditer</button></Link>{' '}
                  <button className="danger" onClick={() => handleDelete(p.id)}>Supprimer</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </>
  );
}
